import { EventType, PublicClientApplication } from "@azure/msal-browser";

import { writeSharedAccount } from "../utils/authSync";

const ua = window.navigator.userAgent;
const msie = ua.indexOf("MSIE ");
const msie11 = ua.indexOf("Trident/");
const msedge = ua.indexOf("Edge/");
const firefox = ua.indexOf("Firefox");
const isIE = msie > 0 || msie11 > 0;
const isEdge = msedge > 0;
const isFirefox = firefox > 0;

export const msalConfig = {
  auth: {
    clientId: import.meta.env.VITE_AZURE_CLIENT_ID,
    authority: `https://login.microsoftonline.com/${
      import.meta.env.VITE_AZURE_TENANT_ID
    }`,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: "/"
  },
  cache: {
    storeAuthStateInCookie: isIE || isEdge || isFirefox,
    cacheLocation: "localStorage"
  }
};

export const loginRequest = {
  scopes: [
    "openid",
    "profile",
    "email",
    "offline_access",
    "User.Read"
    // "Group.Read.All"
  ]
};

// Azure AD only allows one resource per token request, so the BFF's own
// app-registration scope is requested separately from the Graph scopes above.
export const bffLoginRequest = {
  scopes: ["api://d00a1190-0497-49ba-ae24-21f4cb9241bf/access_as_user"]
};

export const msalInstance = new PublicClientApplication(msalConfig);

msalInstance.addEventCallback((event: any) => {
  if (event.eventType === EventType.LOGIN_SUCCESS) {
    const account = event.payload.account;

    msalInstance.setActiveAccount(account);
    // Let the sibling app detect a logout or an account switch here.
    writeSharedAccount(account.homeAccountId);
  }
});
